<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: "PublicLayout"
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/layouts/PublicLayout.vue